import { createEntityClient, runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { processContract } from './processContract';
import type { ProcessType } from './types/model';

/**
 * Processes of the selected project, as served by the service worker. A
 * workflow change resolves with the process the server saved and rejects with
 * its error (`ChannelRequestError.messageId`).
 */
export const processClient = {
  ...createEntityClient(processContract),

  updateWorkflow(processId: string, workflowId: string, projectId: string): Promise<ProcessType> {
    return runQueuedMutation(
      processContract,
      'updateWorkflow',
      (uniqueId) => ({ processId, workflowId, projectId, uniqueId }),
      DomainMessagesTypes.updatedProcess,
      { failureType: DomainMessagesTypes.processError }
    );
  },
};
